import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c1d5938"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增费用类别")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导出维护")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加事项")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("关联流程")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定")

import { Ref, ref, onBeforeMount, reactive } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import PayItemMaintain from '@/views/payItemMaintain.vue'
import { paymentTypeOption } from '@/views/typeMapping/Financial';
import { exportHandle } from '@/utils';
import Api from '@/http/modules/index'
import { ElMessage, ElMessageBox } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 获取费用类别
  'GET/invoice_expense_categorys/tree': categorysTreeApi,
  // 创建费用类别/事项
  'POST/invoice_expense_categorys': createdApi,
  // 修改
  'PATCH/invoice_expense_categorys': editApi,
  // 删除
  'DELETE/invoice_expense_categorys/{id}': delApi,
  // 获取审批流程
  'GET/flw_approval_process/list': approval_itemApi,
  // 新增/更新-审批模板关联模块
  'POST/flw_relate_approvals': relate_approvalsApi,
  // 所有现金流科目(下拉框)
  'GET/cash_flow_subject': cash_flow_subjectApi,
  // 所有凭证科目(下拉框)
  'GET/voucher_subject': voucher_subjectApi,
  // 凭证科目_获取所有子科目全名
  'GET/voucher_subject/child_full_name': child_full_nameApi,
  // 新增费用类别
  'POST/invoice_expense_categorys/download': downloadApi,
} = Api


let { 
  MI_tableData, fetchData, page, size, MI_height,
  MI_total, MI_pageChange, MI_identify, MI_modifyForm
} = new tbMix(categorysTreeApi)



let departmentJobsData: Ref<object[]> = ref([])
const isPageLoad = ref<boolean>(false)
const initializationFunc = () => {
  isPageLoad.value = true
  categorysTreeApi().then((rep: any) => {
    departmentJobsData.value = rep
  }).finally(() => {
    isPageLoad.value = false
  })
}

let approvalList: any = ref([])
let paymentDropList: any = ref([])
let flowSubjectList: any = ref([])
let subjectList: any = ref([])
onBeforeMount(() => {
  initializationFunc()

    // 获取款型类型
  paymentTypeOption().then((rep: any) => {
    paymentDropList.value = rep
  })

  approval_itemApi().then(rep => {
    approvalList.value = rep
  })
  // 获取现金流科目
  cash_flow_subjectApi().then((rep: any) => {
    flowSubjectList.value = rep
  })
  // 获取所有凭证科目
  /* voucher_subjectApi().then((rep: any) => {
    subjectList.value = rep
  }) */

  child_full_nameApi().then((rep: any) => {
    subjectList.value = rep
  })
})

// 添加费用类别
const isEleLoading = ref<boolean>(false)
const addEle = ref()
const isShowAddCategory = ref<boolean>(false)
const addSubjectObj = reactive({
  number: '', name:'', paymentType: '',
  allocation: '', cashFlowSubjectId: '',
  voucherSubjectFullName: '', id: '',
})
const ShowAddCategorys = () => {
  isShowAddCategory.value = true
  addEle.value?.resetFields()
}
const submitAddition = () => {
  addEle.value.validate().then((valid: boolean) => {
    if(valid === false) return Promise.reject();
    isEleLoading.value = true
    return createdApi({ pid: 0, level: 1, ...addSubjectObj})
  }).then(() => {
    isShowAddCategory.value = false
    ElMessage.success('添加成功')
    initializationFunc()
  }).finally(() => {
    isEleLoading.value = false
  })
}

// 修改费用类别
const isShowEditCategory = ref<boolean>(false)
const editSubjectObj = reactive({
  number: '', name:'', paymentType: '',
  allocation: '', cashFlowSubjectId: '',
  voucherSubjectFullName: '', id: '', firstSubject: '',
})
const editCategory = (row: any) => {
  Object.assign(editSubjectObj, {
    number: row.number,
    name: row.name,
    paymentType: row.paymentType,
    allocation: row.allocation,
    cashFlowSubjectId: row.cashFlowSubjectId,
    voucherSubjectFullName: row.voucherSubjectFullName,
    id: row.id,
    firstSubject: row.firstSubject,
    purpose: row.purpose,

  })
  isShowEditCategory.value = true
}
const submitEdit = () => {
  addEle.value.validate().then((valid: boolean) => {
    if(valid === false) return Promise.reject();
    isEleLoading.value = true
    return editApi(editSubjectObj)
  }).then(() => {
    isShowEditCategory.value = false
    ElMessage.success('修改成功')
    initializationFunc()
  }).finally(() => {
    isEleLoading.value = false
  })
}

// 添加事项
const isShowAddItem = ref<boolean>(false)
const addItemObj = reactive({
  number: '',
  name: '',
  paymentType: '',
  allocation: '',
  type: '',
  intercourse: '',
  cashFlowSubjectId: '',
  voucherSubjectFullName: '',
  reportMte: '',
  pid: ''
})
const itemConfig = ref([
  { 
    label: '编号',
    value: '',
    upKey: 'number',
    props: {maxlength: 20},
    rule: [{ required: true, message: '请输入编号', trigger: 'change' }],
  },
  { 
    label: '事项名称',
    value: '',
    upKey: 'name',
    props: {maxlength: 100},
    rule: [{ required: true, message: '请输入事项名称', trigger: 'change' }],
  },
  {
    type: 'SELECT',
    // selectType: 'CASCADER',
    label: '款项类型',
    value: '',
    upKey: 'paymentType',
    options: paymentDropList,
    props: { placeholder: '请选择款项类型'},
    seleProps: { label: 'label', valueName: 'id'},
  },
  {
    type: "SELECT",
    label: "是否分摊",
    value: "",
    upKey: "allocation",
    options: [
      {label: '是', id: true},
      {label: '否', id: false},
    ],
    props: { clearable: false },
    rule: [{ required: true, message: '请选择款是否分摊', trigger: 'change' }],
    seleProps: { },
  },
  {
    type: "SELECT",
    label: "事项明细",
    value: "",
    upKey: "type",
    options: [
      {label: '空', id: 'Empty'},
      {label: '差旅费', id: 'TravelExpense'},
    ],
    props: { clearable: false },
    rule: [{ required: true, message: '请选择款事项明细', trigger: 'change' }],
    seleProps: { },
  },
  {
    type: "SELECT",
    label: "往来请款",
    value: "",
    upKey: "intercourse",
    options: [
      {label: '存在', id: true},
      {label: '不存在', id: false},
    ],
    props: { clearable: false },
    // rule: [{ required: true, message: '请选择往来请款', trigger: 'change' }],
    seleProps: { },
  },
  {
    type: "SELECT",
    label: "现金流科目",
    value: "",
    upKey: "cashFlowSubjectId",
    options: flowSubjectList,
    props: { clearable: false },
    seleProps: { label: 'name', valueName: 'id' },
  },
  {
    type: "SELECT",
    label: "凭证科目全名",
    value: "",
    upKey: "voucherSubjectFullName",
    options: subjectList,
    props: { clearable: false },
    seleProps: { label: 'label', valueName: 'label' },
  },
  {
    type: "SELECT",
    label: "是否合计MTE报表",
    value: "",
    upKey: "reportMte",
    options: [
      {label: '合计', id: 1},
      {label: '不合计', id: 0},
    ],
    props: { clearable: true },
    seleProps: { },
  },
])
const addItemHandle = (row: any) => {
  isShowAddItem.value = true
  addItemObj.pid = row.id
  addEle.value?.resetFields()

  /* MI_modifyForm({}, itemConfig, isShowAddItem, async (params: any) => {
    await createdApi({level: 2, pid: data.id, ...params})
    isShowAddItem.value = false
    ElMessage.success('添加成功')
    initializationFunc()
  }) */
}
const submitAddItem = () => {
  addEle.value.validate().then((valid: boolean) => {
    if(valid === false) return Promise.reject();
    isEleLoading.value = true
    return createdApi({level: 2, ...addItemObj})
  }).then(() => {
    isShowAddItem.value = false
    ElMessage.success('添加事项成功')
    initializationFunc()
  }).finally(() => {
    isEleLoading.value = false
  })
}

// 关联流程
const isShowRelation = ref<boolean>(false)
const relationConfig = ref([
{
    type: 'SELECT',
    label: '审批流程',
    value: '',
    upKey: 'approvalItemId',
    options: approvalList,
    props: { clearable: true, placeholder: '请选择审批流程'},
    seleProps: { label: 'name', valueName: 'id', },

  },
])
const relationHandle = (data: any) => {
  MI_modifyForm({approvalItemId: data.relateApproval?.approvalItemId}, relationConfig, isShowRelation, async (params: any) => {
    await relate_approvalsApi({
      ...params,
      id: data.relateApproval?.id,
      itemId: data.id,
      module:"Expense",
    })
    isShowRelation.value = false
    ElMessage.success('成功')
    initializationFunc()
  })
}

// 修改事项
const isShowEditItem = ref<boolean>(false)
const editItemObj = reactive({
  number: '',
  name: '',
  paymentType: '',
  allocation: '',
  type: '',
  intercourse: '',
  cashFlowSubjectId: '',
  voucherSubjectFullName: '',
  reportMte: '',
  id: '',
})
const editItemHandle = (row: any) => {
  isShowEditItem.value = true
  Object.assign(editItemObj, {    
    number: row.number,
    name: row.name,
    paymentType: row.paymentType,
    allocation: row.allocation,
    type: row.type,
    intercourse: row.intercourse,
    cashFlowSubjectId: row.cashFlowSubjectId,
    voucherSubjectFullName: row.voucherSubjectFullName,
    reportMte: row.reportMte,
    id: row.id,
    firstSubject: row.firstSubject,
    purpose: row.purpose,
  })
}
const submitEditItem = () => {
  addEle.value.validate().then((valid: boolean) => {
    if(valid === false) return Promise.reject();
    isEleLoading.value = true
    return editApi(editItemObj)
  }).then(() => {
    isShowEditItem.value = false
    ElMessage.success('修改事项成功')
    initializationFunc()
  }).finally(() => {
    isEleLoading.value = false
  })
}

// 删除
const delHandle = (data: any)  => {
  ElMessageBox.confirm(
    `请确认是否删除: ${data.name}`,
    '提示',
  )
    .then(() => {
      isPageLoad.value = true
      return delApi(data)
    })
    .then(() => {
      ElMessage.success('删除成功')
      isPageLoad.value = false
      initializationFunc()
    })
    .catch(() => {
      isPageLoad.value = false
    })

}

// 导出
const exportCategorys = () => {
  isPageLoad.value = true
  exportHandle(downloadApi, {}).then(() => {
    ElMessage.success('导出成功')
  }).finally(() => {
    isPageLoad.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_tabs, { type: "border-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, { label: "报销类别维护" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (ShowAddCategorys()))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: exportCategorys }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (initializationFunc())),
              icon: "refresh"
            }),
            _createVNode(_component_el_table, {
              data: _unref(departmentJobsData),
              "row-key": "id",
              border: "",
              "max-height": _unref(MI_height) + 'px',
              class: "mt-10"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "number",
                  label: "类别",
                  width: "450"
                }, {
                  default: _withCtx(({row}) => [
                    _createTextVNode(_toDisplayString(`${row.number} ${row.name}`), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "voucherSubjectFullName",
                  label: "凭证科目全名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "cashFlowSubjectName",
                  label: "现金流科目"
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        (row.level === 1)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              onClick: ($event: any) => (addItemHandle(row)),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (row.level === 2)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 1,
                              onClick: ($event: any) => (relationHandle(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (row.level === 1)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 2,
                              onClick: ($event: any) => (editCategory(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (row.level === 2)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 3,
                              onClick: ($event: any) => (editItemHandle(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_link, {
                          type: "danger",
                          onClick: ($event: any) => (delHandle(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"]),
            _createVNode(_component_el_dialog, {
              modelValue: isShowAddCategory.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isShowAddCategory).value = $event)),
              width: "600px",
              title: "新增费用类别"
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_el_button, {
                  disabled: isEleLoading.value,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (isShowAddCategory.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  loading: isEleLoading.value,
                  type: "primary",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (submitAddition()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref_key: "addEle",
                  ref: addEle,
                  model: _unref(addSubjectObj),
                  "label-position": "top",
                  inline: "",
                  disabled: isEleLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "编号:",
                      prop: "number"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(addSubjectObj).number,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addSubjectObj).number) = $event)),
                          placeholder: "请输入编号",
                          maxlength: "100",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "费用类别名称:",
                      prop: "name",
                      rules: [{ required: true, message: '请输入费用类别名称', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(addSubjectObj).name,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(addSubjectObj).name) = $event)),
                          placeholder: "请输入费用类别名称",
                          maxlength: "200",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "款项类型:",
                      prop: "paymentType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addSubjectObj).paymentType,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addSubjectObj).paymentType) = $event)),
                          placeholder: "请选择款项类型",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentDropList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "是否分摊:",
                      prop: "allocation",
                      rules: [{ required: true, message: '请选择款是否分摊', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addSubjectObj).allocation,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addSubjectObj).allocation) = $event)),
                          placeholder: "请选择是否分摊"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "是",
                              value: true
                            }),
                            _createVNode(_component_el_option, {
                              label: "否",
                              value: false
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "现金流科目:",
                      prop: "cashFlowSubjectId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addSubjectObj).cashFlowSubjectId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addSubjectObj).cashFlowSubjectId) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flowSubjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目全名:",
                      prop: "voucherSubjectFullName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addSubjectObj).voucherSubjectFullName,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addSubjectObj).voucherSubjectFullName) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目(一级):",
                      prop: "firstSubject"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(addSubjectObj).firstSubject,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addSubjectObj).firstSubject) = $event)),
                          placeholder: "请输入凭证科目",
                          clearable: "",
                          maxlength: "100"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "用途:",
                      prop: "purpose"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "formItem",
                          modelValue: _unref(addSubjectObj).purpose,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addSubjectObj).purpose) = $event)),
                          placeholder: "请选择用途",
                          clearable: "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "费用报销",
                              value: "Expense"
                            }),
                            _createVNode(_component_el_option, {
                              label: "用款申请",
                              value: "CostApply"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_dialog, {
              modelValue: isShowEditCategory.value,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((isShowEditCategory).value = $event)),
              width: "600px",
              title: "修改费用类别"
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_el_button, {
                  disabled: isEleLoading.value,
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (isShowEditCategory.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  loading: isEleLoading.value,
                  type: "primary",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (submitEdit()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref_key: "addEle",
                  ref: addEle,
                  model: _unref(editSubjectObj),
                  "label-position": "top",
                  inline: "",
                  disabled: isEleLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "编号:",
                      prop: "number"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(editSubjectObj).number,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(editSubjectObj).number) = $event)),
                          placeholder: "请输入编号",
                          maxlength: "100",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "费用类别名称:",
                      prop: "name",
                      rules: [{ required: true, message: '请输入费用类别名称', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(editSubjectObj).name,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(editSubjectObj).name) = $event)),
                          placeholder: "请输入费用类别名称",
                          maxlength: "200",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "款项类型:",
                      prop: "paymentType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editSubjectObj).paymentType,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(editSubjectObj).paymentType) = $event)),
                          placeholder: "请选择款项类型",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentDropList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "是否分摊:",
                      prop: "allocation",
                      rules: [{ required: true, message: '请选择款是否分摊', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editSubjectObj).allocation,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(editSubjectObj).allocation) = $event)),
                          placeholder: "请选择是否分摊"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "是",
                              value: true
                            }),
                            _createVNode(_component_el_option, {
                              label: "否",
                              value: false
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "现金流科目:",
                      prop: "cashFlowSubjectId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editSubjectObj).cashFlowSubjectId,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(editSubjectObj).cashFlowSubjectId) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flowSubjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目全名:",
                      prop: "voucherSubjectFullName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editSubjectObj).voucherSubjectFullName,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(editSubjectObj).voucherSubjectFullName) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目(一级):",
                      prop: "firstSubject"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(editSubjectObj).firstSubject,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(editSubjectObj).firstSubject) = $event)),
                          placeholder: "请输入凭证科目",
                          clearable: "",
                          maxlength: "100"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "用途:",
                      prop: "purpose"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "formItem",
                          modelValue: _unref(editSubjectObj).purpose,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(editSubjectObj).purpose) = $event)),
                          placeholder: "请选择用途",
                          clearable: "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "费用报销",
                              value: "Expense"
                            }),
                            _createVNode(_component_el_option, {
                              label: "用款申请",
                              value: "CostApply"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_dialog, {
              modelValue: isShowAddItem.value,
              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((isShowAddItem).value = $event)),
              width: "600px",
              title: "新增事项"
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_el_button, {
                  disabled: isEleLoading.value,
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (isShowAddItem.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  loading: isEleLoading.value,
                  type: "primary",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (submitAddItem()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref_key: "addEle",
                  ref: addEle,
                  model: _unref(addItemObj),
                  "label-position": "top",
                  inline: "",
                  disabled: isEleLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "编号:",
                      prop: "number"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(addItemObj).number,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(addItemObj).number) = $event)),
                          placeholder: "请输入编号",
                          maxlength: "100",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "事项名称:",
                      prop: "name",
                      rules: [{ required: true, message: '请输入事项名称', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(addItemObj).name,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(addItemObj).name) = $event)),
                          placeholder: "请输入事项名称",
                          maxlength: "100",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "款项类型:",
                      prop: "paymentType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addItemObj).paymentType,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(addItemObj).paymentType) = $event)),
                          placeholder: "请选择款项类型",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentDropList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "是否分摊:",
                      prop: "allocation",
                      rules: [{ required: true, message: '请选择款是否分摊', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addItemObj).allocation,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(addItemObj).allocation) = $event)),
                          placeholder: "请选择是否分摊"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "是",
                              value: true
                            }),
                            _createVNode(_component_el_option, {
                              label: "否",
                              value: false
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "事项明细:",
                      prop: "type",
                      rules: [{ required: true, message: '请选择款事项明细', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addItemObj).type,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(addItemObj).type) = $event)),
                          placeholder: "请选择事项明细"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "空",
                              value: "Empty"
                            }),
                            _createVNode(_component_el_option, {
                              label: "差旅费",
                              value: "TravelExpense"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "往来请款:",
                      prop: "intercourse"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addItemObj).intercourse,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(addItemObj).intercourse) = $event)),
                          placeholder: "请选择往来请款"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "存在",
                              value: true
                            }),
                            _createVNode(_component_el_option, {
                              label: "不存在",
                              value: false
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "现金流科目:",
                      prop: "cashFlowSubjectId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addItemObj).cashFlowSubjectId,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(addItemObj).cashFlowSubjectId) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flowSubjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目全名:",
                      prop: "voucherSubjectFullName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addItemObj).voucherSubjectFullName,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(addItemObj).voucherSubjectFullName) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "是否合计MTE报表:",
                      prop: "reportMte"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addItemObj).reportMte,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(addItemObj).reportMte) = $event)),
                          placeholder: "请选择是否合计MTE报表"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "合计",
                              value: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "不合计",
                              value: 0
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目(一级):",
                      prop: "firstSubject"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(addItemObj).firstSubject,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(addItemObj).firstSubject) = $event)),
                          placeholder: "请输入凭证科目",
                          clearable: "",
                          maxlength: "100"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "用途:",
                      prop: "purpose"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "formItem",
                          modelValue: _unref(addItemObj).purpose,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(addItemObj).purpose) = $event)),
                          placeholder: "请选择用途",
                          clearable: "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "费用报销",
                              value: "Expense"
                            }),
                            _createVNode(_component_el_option, {
                              label: "用款申请",
                              value: "CostApply"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_dialog, {
              modelValue: isShowRelation.value,
              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((isShowRelation).value = $event)),
              draggable: "",
              width: "600px",
              title: "审批关联"
            }, {
              default: _withCtx(() => [
                (isShowRelation.value)
                  ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
              searchConfig: relationConfig.value,
              submitText: '确定'
            })), null, 16))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_dialog, {
              modelValue: isShowEditItem.value,
              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((isShowEditItem).value = $event)),
              width: "600px",
              title: "修改事项"
            }, {
              footer: _withCtx(() => [
                _createVNode(_component_el_button, {
                  disabled: isEleLoading.value,
                  onClick: _cache[50] || (_cache[50] = ($event: any) => (isShowEditItem.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  loading: isEleLoading.value,
                  type: "primary",
                  onClick: _cache[51] || (_cache[51] = ($event: any) => (submitEditItem()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref_key: "addEle",
                  ref: addEle,
                  model: _unref(editItemObj),
                  "label-position": "top",
                  inline: "",
                  disabled: isEleLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "编号:",
                      prop: "number"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(editItemObj).number,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(editItemObj).number) = $event)),
                          placeholder: "请输入编号",
                          maxlength: "100",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "事项名称:",
                      prop: "name",
                      rules: [{ required: true, message: '请输入事项名称', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(editItemObj).name,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(editItemObj).name) = $event)),
                          placeholder: "请输入事项名称",
                          maxlength: "100",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "款项类型:",
                      prop: "paymentType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editItemObj).paymentType,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(editItemObj).paymentType) = $event)),
                          placeholder: "请选择款项类型",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentDropList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "是否分摊:",
                      prop: "allocation",
                      rules: [{ required: true, message: '请选择款是否分摊', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editItemObj).allocation,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(editItemObj).allocation) = $event)),
                          placeholder: "请选择是否分摊"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "是",
                              value: true
                            }),
                            _createVNode(_component_el_option, {
                              label: "否",
                              value: false
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "事项明细:",
                      prop: "type",
                      rules: [{ required: true, message: '请选择款事项明细', trigger: 'change' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editItemObj).type,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(editItemObj).type) = $event)),
                          placeholder: "请选择事项明细"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "空",
                              value: "Empty"
                            }),
                            _createVNode(_component_el_option, {
                              label: "差旅费",
                              value: "TravelExpense"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "往来请款:",
                      prop: "intercourse"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editItemObj).intercourse,
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref(editItemObj).intercourse) = $event)),
                          placeholder: "请选择往来请款"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "存在",
                              value: true
                            }),
                            _createVNode(_component_el_option, {
                              label: "不存在",
                              value: false
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "现金流科目:",
                      prop: "cashFlowSubjectId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editItemObj).cashFlowSubjectId,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_unref(editItemObj).cashFlowSubjectId) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flowSubjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目全名:",
                      prop: "voucherSubjectFullName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editItemObj).voucherSubjectFullName,
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(editItemObj).voucherSubjectFullName) = $event)),
                          placeholder: "请选择现金流科目",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectList), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "是否合计MTE报表:",
                      prop: "reportMte"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(editItemObj).reportMte,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(editItemObj).reportMte) = $event)),
                          placeholder: "请选择是否合计MTE报表"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "合计",
                              value: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "不合计",
                              value: 0
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证科目(一级):",
                      prop: "firstSubject"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "form-input",
                          modelValue: _unref(editItemObj).firstSubject,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(editItemObj).firstSubject) = $event)),
                          placeholder: "请输入凭证科目",
                          clearable: "",
                          maxlength: "100"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "用途:",
                      prop: "purpose"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "formItem",
                          modelValue: _unref(editItemObj).purpose,
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_unref(editItemObj).purpose) = $event)),
                          placeholder: "请选择用途",
                          clearable: "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "费用报销",
                              value: "Expense"
                            }),
                            _createVNode(_component_el_option, {
                              label: "用款申请",
                              value: "CostApply"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])), [
            [_directive_loading, isPageLoad.value]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, { label: "报销项目维护" }, {
        default: _withCtx(() => [
          _createVNode(PayItemMaintain)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})